import React, { useState, useEffect } from 'react'
import { Box, Flex, Button, Modal, Text } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { getPackingList, deletePackingList } from '../../../../services/packing'
import { useParams } from 'react-router-dom'
import PackageItemsList from '../Package/LayoutHelper/PackageItemsList'
import FormAdjustPackageItem from '../Package/Form/FormAdjustPackageItem'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData' 


const OrderPackageItems = () => {
  const params = useParams()
  const orderId = params.order_id
  const [loadingPackageItems, setLoadingPackageItems] = useState(true)
  const [packageItemsList, setPackageItemsList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetDataPackingList = async () => {
    setLoadingPackageItems(true)
    const params = {
      'include': 'items,images',
      'filter[order_id][is]': orderId
    }
    try {
      const response = await getPackingList(params)
      if (response.success) {
        const dataPackage = response.data
        const dataItems = response.included.items || []
        // const dataImages = response.included.images || []

        const countTotalCBM = (dataPackage) => {
          let totalCBM = 0
          if (dataPackage.length > 0) {
            const countData = dataPackage.reduce((accumulator, val) => {
              let calculateDimens = 0
              const packageDimension = val.attributes.dimensions

              const findHeight = packageDimension.find(val => val.label === 'height').value
              const findWidth = packageDimension.find(val => val.label === 'width').value
              const findLength = packageDimension.find(val => val.label === 'length').value

              if (val.attributes.dimension_unit === 'meters') {
                calculateDimens = Number(findWidth) * Number(findHeight) * Number(findLength)
              } else if (val.attributes.dimension_unit === 'inchs') {
                calculateDimens = (Number(findWidth) / 39.37) * (Number(findHeight) / 39.37) * (Number(findLength) / 39.37)
              } else if (val.attributes.dimension_unit === 'cms') {
                calculateDimens = (Number(findWidth) / 100) * (Number(findHeight) / 100) * (Number(findLength) / 100)
              } 

              return accumulator + (calculateDimens * val.attributes.package_qty)
            }, 0)

            totalCBM = countData
          }
          return totalCBM % 1 === 0 ? totalCBM : totalCBM.toFixed(4)
        }

        const remapData = dataPackage.map((val, index) => {
          const relateItems = val.relationships.items.map((item) => {
            const data = dataItems[item.id]
            return {
              item_id: data.attributes.id,
              name: data.attributes.product_name,
              qty: data.attributes.pivot.qty,
              qty_unit: data.attributes.pivot.qty_unit,
              image_url: data.attributes.image_url,
              creator: null,
              updater: null
            }
          })

          return {
            id: val.attributes.id,
            marks: val.attributes.marks,
            package_qty: val.attributes.package_qty,
            order_items: relateItems,
            package_type: val.attributes.package_type,
            item_qty: val.attributes.item_qty,
            net_weight: val.attributes.net_weight,
            gross_weight: val.attributes.gross_weight,
            dimensions: val.attributes.dimensions,
            unit_dimension: val.attributes.dimension_unit,
            cbm: countTotalCBM([val]),
            total_cbm : Number(countTotalCBM([val])) * val.attributes.package_qty,
            total_net_weight: val.attributes.net_weight * val.attributes.package_qty,
            total_gross_weight: val.attributes.gross_weight * val.attributes.package_qty,
            images: null,
            created_at: val.attributes.created_at,
            updated_at: val.attributes.updated_at,
            package_id: val.attributes.package_id
          }
        })
        setPackageItemsList(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingPackageItems(false)
    }
  }

  useEffect(() => {
    handleGetDataPackingList()
    // eslint-disable-next-line
  }, [orderId])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('package items', val.id, val.marks, deletePackingList, handleGetDataPackingList)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={10}>
        <Flex justify='flex-end' align='center' my={20}>
          <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Package Item</Button>
        </Flex>
      </Box>
      <Box my={30}> 
        {loadingPackageItems ? <LoadingData /> : packageItemsList.length > 0 ? <PackageItemsList packageItems={packageItemsList} actionMethod={handleAction} showUser={false} /> : <NoData />}
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='75%' title={<Text fw='Bold'>{detailData !== null ? 'Update' : 'Create'} Package Item</Text>} withCloseButton={false}>
        <FormAdjustPackageItem dataItem={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetDataPackingList} />
      </Modal>
    </Box>
  )
}

export default OrderPackageItems